import './buttons.css'

const Social = ({link, color, icon}) => {

      return (
            <a className={color} href={link} target="_blank" rel="noreferrer">{icon}</a>
      )
}

export default Social
